<template>
  <div>
    <b-card-body>
      <b-card class="chart-meta-config-container">
        <b-form>
          <b-form-group label="Indicador:" label-for="indicatorSelect">
            <b-input-group class="align-items-center">
              <v-select
                id="indicatorSelect"
                class="search-select flex-grow-1 cursor-point"
                v-model="localConfig.indicator"
                :options="indicatorOptions"
                label="text"
                :reduce="opt => opt.value"
                placeholder="Digite ou Selecione um Indicador."
                :clearable="false"
                :searchable="true"
              >
                <template #no-options>Digite para filtrar…</template>
              </v-select>

              <b-input-group-prepend is-text class="icon-prepend cursor-point">
                <img src="@/assets/buscar.png" width="25" height="25" alt="buscar" />
              </b-input-group-prepend>
            </b-input-group>
          </b-form-group>

          <b-form-group class="mt-2" label="Meta:" label-for="metaInput">
            <b-form-input
              id="metaInput"
              v-model="localConfig.metaValue"
              placeholder="Digite o valor da meta"
              type="text"
              @input="handleNumberInput"
            />
          </b-form-group>

          <div class="modal-buttons text-right">
            <img
              class="action-btn"
              width="30"
              height="30"
              src="@/assets/salvar.png"
              :title="$t('salvar')"
              @click="saveMetaConfig"
            />
            <img
              class="action-btn ml-2 exit-btn"
              width="30"
              height="30"
              src="@/assets/sair.png"
              :title="$t('cancelar')"
              @click="$emit('close')"
            />
          </div>
        </b-form>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'ChartMetaConfigModal',
  components: { vSelect },
  props: {
    indicators: { type: Array, required: true },
    config: { type: Object, default: () => ({ indicator: null, metaValue: '' }) }
  },
  data() {
    return { localConfig: { ...this.config } }
  },
  computed: {
    indicatorOptions() {
      return this.indicators.map(ind => ({
        value: ind,
        text: ind.indicatorName
      }))
    }
  },
  watch: {
    config(newVal) {
      this.localConfig = { ...newVal }
    }
  },
  methods: {
    handleNumberInput(value) {
      let cleaned = value.replace(/[^\d,.]/g, '')
      cleaned = cleaned.replace(',', '.')
      const parts = cleaned.split('.')
      if (parts.length > 2) {
        cleaned = parts[0] + '.' + parts.slice(1).join('')
      }
      this.localConfig.metaValue = cleaned
    },
    saveMetaConfig() {
      if (!this.localConfig.indicator) {
        this.$bvToast.toast('Digite ou Selecione um Indicador.', {
          title: 'Atenção',
          variant: 'warning',
          toaster: 'b-toaster-bottom-left',
          solid: true
        })
        return
      }
      if (!this.localConfig.metaValue || this.localConfig.metaValue.trim() === '') {
        this.$bvToast.toast('Digite um valor para a meta.', {
          title: 'Atenção',
          variant: 'warning',
          solid: true
        })
        return
      }
      const numericValue = parseFloat(this.localConfig.metaValue)
      if (isNaN(numericValue)) {
        this.$bvToast.toast('Digite um valor numérico válido para a meta.', {
          title: 'Atenção',
          variant: 'warning',
          solid: true
        })
        return
      }
      this.$emit('save', {
        ...this.localConfig,
        metaValue: numericValue.toString()
      })
    }
  }
}
</script>

<style scoped>
.chart-meta-config-container {
  padding: 7px;
}

.icon-prepend {
  margin-left: 10px;
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  padding-right: 6px;
}

.icon-prepend img {
  display: block;
}

.search-select .vs__dropdown-toggle {
  border: 1px solid #ced4da;
  cursor: pointer !important;
}

.search-select .vs__dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.search-select:hover .vs__dropdown-toggle,
.search-select:hover .vs__search,
.search-select:hover .vs__selected-options,
.search-select:hover .vs__actions {
  cursor: pointer;
}

.modal-buttons {
  margin-top: 25px;
}

.action-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  margin-top: 10px;
}

.exit-btn {
  margin-left: 14px;
  margin-right: 0 !important;
}

.search-select .vs__search {
  cursor: pointer;
}

.icon-prepend .input-group-text {
  background-color: transparent !important; 
  border: none !important;                  
  padding: 0 6px;                           
}

.cursor-point 
{
  cursor: pointer;
}
</style>
